var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var waveCartUtils = (function () {
    var BUNDLE_PROPERTY_KEY = '__bundle';
    function post(url, body) {
        return fetch(url, {
            method: "POST",
            body: JSON.stringify(body),
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    function get(url) {
        return fetch(url, {
            credentials: "same-origin",
            method: "GET"
        });
    }
    function getCart() {
        console.log('waveLiquidRoutes', waveLiquidRoutes);
        var url = "".concat(waveLiquidRoutes.cart, ".js?t=" + Date.now());
        return get(url).then(function (response) { return response.json(); });
    }
    // Refer to cart.json.liquid for exact structure
    function getLiquidCart() {
        var url = "".concat(waveLiquidRoutes.cart, "?view=json&t=" + Date.now());
        return get(url).then(function (response) { return response.json(); });
    }
    function changeItem(_a) {
        var key = _a.key, quantity = _a.quantity, properties = _a.properties;
        return post(waveLiquidRoutes.cartChange, {
            id: key,
            quantity: quantity,
            properties: properties
        });
    }
    function addItems(items) {
        return post(waveLiquidRoutes.cartAdd, { items: items }).then(function (response) {
            return response.json();
        });
    }
    function findDummy(cart, key) {
        return cart.items.find(function (item) {
            return (item.properties[BUNDLE_PROPERTY_KEY] &&
                item.properties[BUNDLE_PROPERTY_KEY]["rule"] == "bundle" &&
                item.properties[BUNDLE_PROPERTY_KEY]["key"] == key &&
                item.properties[BUNDLE_PROPERTY_KEY]["set"] == null);
        });
    }
    function checkoutPageBundleCheck() {
        function isDummy(item) {
            return item.product.tags.some(function (tag) { return tag.includes("rule:bundle"); });
        }
        function promoProp(item) {
            var props = item.properties.find(function (props) { return props[0] == BUNDLE_PROPERTY_KEY; });
            if (props) {
                return props[1];
            }
        }
        function bundleSet(item) {
            return isDummy(item) ? "&dummy&" : promoProp(item)["set"];
        }
        function bundleKey(item) {
            return promoProp(item)["key"];
        }
        var tmp = document.getElementById("wave-checkout-cart");
        var lineItems = JSON.parse(tmp.textContent.trim())["line_items"];
        var hasIncompleteBundle = false;
        var bundleItems = lineItems.filter(function (item) {
            var prop = promoProp(item);
            return prop && prop["rule"] == "bundle";
        });
        var itemGroupByKey = {};
        for (var _i = 0, bundleItems_1 = bundleItems; _i < bundleItems_1.length; _i++) {
            var item = bundleItems_1[_i];
            var key = bundleKey(item);
            itemGroupByKey[key] = itemGroupByKey[key] || [];
            itemGroupByKey[key].push(item);
        }
        console.log(itemGroupByKey);
        for (var _a = 0, _b = Object.entries(itemGroupByKey); _a < _b.length; _a++) {
            var _c = _b[_a], key = _c[0], items = _c[1];
            var dummy = items.find(function (item) { return isDummy(item); });
            var tag = dummy.product.tags.find(function (tag) { return tag.includes("rule:bundle"); });
            var promoSets = tag
                .split("|")
                .find(function (token) { return token.startsWith("set:"); })
                .slice("set:".length)
                .split("&")
                .filter(function (i) { return i; })
                .concat(["&dummy&"]);
            console.log(promoSets);
            var itemGroupBySet = {};
            var promoSetQty = {};
            for (var _d = 0, promoSets_1 = promoSets; _d < promoSets_1.length; _d++) {
                var promoSet = promoSets_1[_d];
                itemGroupBySet[promoSet] = [];
                promoSetQty[promoSet] = 0;
            }
            for (var _e = 0, items_1 = items; _e < items_1.length; _e++) {
                var item = items_1[_e];
                var promoSet = bundleSet(item);
                if (!promoSets.includes(promoSet)) {
                    continue;
                }
                itemGroupBySet[promoSet].push(item);
                promoSetQty[promoSet] = promoSetQty[promoSet] + item.quantity;
            }
            var expectedQty = Math.min.apply(Math, Object.values(promoSetQty));
            for (var _f = 0, promoSets_2 = promoSets; _f < promoSets_2.length; _f++) {
                var promoSet = promoSets_2[_f];
                if (promoSetQty[promoSet] > expectedQty) {
                    hasIncompleteBundle = true;
                }
            }
        }
        if (hasIncompleteBundle) {
            window.location.href = waveLiquidRoutes.cart;
        }
    }
    function bundleClean() {
        return __awaiter(this, void 0, void 0, function () {
            function isCheckingOut() {
                return (Shopify &&
                    Shopify.Checkout &&
                    (Shopify.Checkout.page === "show" ||
                        Shopify.Checkout.page === "stock_problems"));
            }
            var _a, cart, products, bundles, expectedQty, _i, _b, item, key, productSet, _c, _d, set, updated, _e, _f, item, key, qty;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (isCheckingOut()) {
                            checkoutPageBundleCheck();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getLiquidCart()];
                    case 1:
                        _a = _g.sent(), cart = _a.cart, products = _a.products;
                        bundles = new Set();
                        expectedQty = {};
                        for (_i = 0, _b = cart.items; _i < _b.length; _i++) {
                            item = _b[_i];
                            if (item.properties && item.properties[BUNDLE_PROPERTY_KEY] &&
                                item.properties[BUNDLE_PROPERTY_KEY]["rule"] == "bundle") {
                                key = item.properties[BUNDLE_PROPERTY_KEY]["key"];
                                productSet = item.properties[BUNDLE_PROPERTY_KEY]["set"] || "";
                                if (!(key in expectedQty)) {
                                    expectedQty[key] = { "": 0 };
                                    for (_c = 0, _d = key.split("|").map(function (i) { return i.split(":")[0]; }); _c < _d.length; _c++) {
                                        set = _d[_c];
                                        expectedQty[key][set] = 0;
                                    }
                                }
                                if (productSet in expectedQty[key]) {
                                    expectedQty[key][productSet] =
                                        expectedQty[key][productSet] + item.quantity;
                                }
                            }
                        }

                        updated = false;
                        _e = 0, _f = cart.items;
                        _g.label = 2;
                    case 2:
                        if (!(_e < _f.length)) return [3 /*break*/, 5];
                        item = _f[_e];
                        if (!(item.properties && item.properties[BUNDLE_PROPERTY_KEY] &&
                            item.properties[BUNDLE_PROPERTY_KEY]["rule"] == "bundle")) return [3 /*break*/, 4];
                        key = item.properties[BUNDLE_PROPERTY_KEY]["key"];
                        qty = Math.min.apply(Math, Object.values(expectedQty[key]));
                        if (!(qty != item.quantity)) return [3 /*break*/, 4];
                        return [4 /*yield*/, changeItem({ key: item.key, quantity: qty })];
                    case 3:
                        _g.sent();
                        updated = true;
                        _g.label = 4;
                    case 4:
                        _e++;
                        return [3 /*break*/, 2];
                    case 5:
                        if (updated) {
                            if (isCheckingOut()) {
                                window.location.reload();
                            }
                            else {
                                document.dispatchEvent(new CustomEvent("cart:build", {}));
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    return {
        changeItem: changeItem,
        getLiquidCart: getLiquidCart,
        getCart: getCart,
        addItems: addItems,
        bundleClean: bundleClean,
        checkoutPageBundleCheck: checkoutPageBundleCheck
    };
})();
waveCartUtils.bundleClean();
